import { getUserSetting, setUserSetting } from '@/common/utils/userSettings'

/**
 * Check if a warning has been dismissed by the user
 * @param userId - The current user ID
 * @param key - Unique key for this warning (e.g., 'hide-warning-{featureId}')
 * @returns true if user dismissed this warning
 */
export const isWarningDismissed = (userId: number, key: string): boolean =>
  Boolean(getUserSetting(userId, key))

/**
 * Mark a warning as dismissed by the user (persists to localStorage)
 * @param userId - The current user ID
 * @param key - Unique key for this warning (e.g., 'hide-warning-{featureId}')
 */
export const dismissWarning = (userId: number, key: string): void =>
  setUserSetting(userId, key, true)
